var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistBordersOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 125,
    viewBox: "0 0 213 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35938 121.158C5.92546 123.367 7.92201 125 10.2981 125H190.053C202.726 125 213 114.679 213 101.946V10.3697C213 7.89387 211.252 5.82824 208.928 5.35059C209.075 6.26358 209.159 7.19816 209.173 8.1495C209.936 8.59209 210.45 9.42061 210.45 10.3697V101.946C210.45 113.264 201.318 122.439 190.053 122.439H10.2981C9.35438 122.439 8.53039 121.924 8.08953 121.158H5.35938Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.26001 116.034C0.826097 118.244 2.82265 119.876 5.19878 119.876H188.778C199.339 119.876 207.901 111.275 207.901 100.665V5.24592C207.901 2.85875 206.275 0.852911 204.076 0.28418V3.02705C204.838 3.46997 205.351 4.29779 205.351 5.24592V100.665C205.351 104.535 204.036 108.098 201.831 110.925C201.048 112.027 200.088 112.992 198.991 113.779C196.176 115.994 192.631 117.315 188.778 117.315H5.19878C4.25502 117.315 3.43102 116.8 2.99017 116.034H0.26001Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistBordersOld);
export default __webpack_public_path__ + "static/media/playlist-borders-old.4bc6e0bd4505a298185227c0c0571626.svg";
export { ForwardRef as ReactComponent };